<template>
  <v-row>
    <v-col cols="12" v-if="label" class="py-0">{{ label }}</v-col>
    <v-col>
      <vf-currency-input
        v-model="form.estimatedValueCents"
        :currency="currencyData"
        :label="$t('variation.estimatedValue')"
        outlined
        dense
        persistent-placeholder
        placeholder="0"
        :disabled="isFinalised || onlyAgreedValue"
        @input="$emit('change')"
      />
    </v-col>
    <v-col>
      <vf-currency-input
        v-model="form.originalValueCents"
        :currency="currencyData"
        :label="$t('variation.originalValue')"
        outlined
        dense
        placeholder="0"
        persistent-placeholder
        @change="validationModel.form.originalValueCents.$touch()"
        :error-messages="[...errorMessages('originalValueCents'), ...originalValuesError]"
        :error="!![...errorMessages('originalValueCents'), ...originalValuesError].length"
        :disabled="isFinalised || onlyEstimatedValue || onlyAgreedValue"
        @input="$emit('change')"
      />
    </v-col>
    <v-col>
      <vf-currency-input
        v-model="form.agreedValueCents"
        :currency="currencyData"
        :label="$t('variation.agreedValue')"
        outlined
        dense
        placeholder="0"
        persistent-placeholder
        @change="validationModel.form.agreedValueCents.$touch()"
        :error-messages="[...errorMessages('agreedValueCents'), ...agreedValuesError]"
        :error="!![...errorMessages('agreedValueCents'), ...agreedValuesError].length"
        :disabled="isFinalised || onlyEstimatedValue"
        @input="$emit('change')"
      />
    </v-col>
    <v-col>
      <v-text-field
        v-model="form.eotRequested"
        :label="$t(`variation.eotRequested.${reporter}`)"
        dense
        outlined
        placeholder="0"
        persistent-placeholder
        suffix="days"
        :disabled="isFinalised || onlyEstimatedValue || onlyAgreedValue"
        @input="$emit('change')"
      />
    </v-col>
    <v-col>
      <v-text-field
        v-model="form.eotAgreed"
        :label="$t(`variation.eotAgreed.${reporter}`)"
        dense
        outlined
        placeholder="0"
        persistent-placeholder
        suffix="days"
        :disabled="isFinalised || onlyEstimatedValue || onlyAgreedValue"
        @input="$emit('change')"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ValuesForm',
  props: {
    label: String,
    type: String,
    form: Object,
    currency: String,
    isFinalised: Boolean,
    reporter: String,
    validationModel: Object,
    errorMessages: Function,
    agreedValuesError: {
      type: Array,
      default: () => ([])
    },
    originalValuesError: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      dirty: false
    }
  },
  methods: {
    checkForDirtyness (oldValue, newValue) {
      if (!this.dirty && oldValue !== null && newValue !== null && oldValue !== newValue) {
        this.dirty = true
        this.$emit('dirty')
      }
    }
  },
  computed: {
    currencyData () {
      return { key: this.currency, value: 1 }
    },
    onlyEstimatedValue () {
      return this.type === 'early_warning'
    },
    onlyAgreedValue () {
      return this.type === 'amendment'
    }
  },
  watch: {
    'form.estimatedValueCents' (v, p) {
      this.checkForDirtyness(v, p)
    },
    'form.originalValueCents' (v, p) {
      this.checkForDirtyness(v, p)
    },
    'form.agreedValueCents' (v, p) {
      this.checkForDirtyness(v, p)
    },
    'form.eotRequested' (v, p) {
      this.checkForDirtyness(v, p)
    },
    'form.eotAgreed' (v, p) {
      this.checkForDirtyness(v, p)
    }
  }
}
</script>
